import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
export function DisclaimerBox() {
  return <motion.div className="max-w-3xl mx-auto px-4 mb-12" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} data-id="element-44">
      <div className="bg-soft-red-bg border-l-4 border-soft-red-border p-5 rounded-r-lg shadow-sm flex gap-4 items-start" data-id="element-45">
        <AlertTriangle className="text-soft-red-text shrink-0 mt-1" size={24} data-id="element-46" />
        <div data-id="element-47">
          <h3 className="font-bold text-soft-red-text mb-1 font-serif" data-id="element-48">
            Wichtig:
          </h3>
          <p className="text-soft-red-text/90 text-sm md:text-base leading-relaxed" data-id="element-49">
            Ein Darmverschluss ist ein medizinischer Notfall. Bitte sofort zum
            Tierarzt! Dieser Bericht handelt von der natürlichen Unterstützung
            nach tierärztlicher Behandlung.
          </p>
        </div>
      </div>
    </motion.div>;
}